import { render, staticRenderFns } from "./JobsRaisedToday.vue?vue&type=template&id=55e2cfd2&"
import script from "./JobsRaisedToday.vue?vue&type=script&lang=ts&"
export * from "./JobsRaisedToday.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports